/**
 * Component per centrar el mapa mitjançant una referència cadastral o una adreça utilitzant un AutoComplete
 * Component: RefCadAdrWidget.tsx
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 29/09/2017
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */

import * as React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import AjtAutoComplete from 'ajt-autocomplete-field';
import RefCadAdrWidgetState from '../states/RefCadAdrWidgetState';
import { TextField} from '@material-ui/core';
import * as _ from 'lodash';
import { IPropsRefCadAdrWidget } from '../interfaces/IPropsRefCadAdrWidget';
import { IFincaNumero } from '../interfaces/IRefCadAdr';

@observer
export default class RefCadAdrWidget extends React.Component<IPropsRefCadAdrWidget, object> {

    static defaultProps = {
        // appState: null as any,
        hintText: 'Entra l\'adreça o la referència cadastral',
        floatingLabelText: 'Geolocalitzar per adreça o referència cadastral',
        floatingLabelFixed: true,
        minLength: 3,
        pageSize: 10,
        autoFocus: false,
        finCod: 0,
        finRefCad1: '',
        finRefCad2: '',
        numCod: 0,
        readonly: false,
        errorText: '',
        onChange: _.noop,
        required: false
    };

    // El estat del widget
    private rcState: RefCadAdrWidgetState = new RefCadAdrWidgetState(this.props.proxyWebApi, this.props.numCod, this.props.finCod);

    // Llegim la llista d'adreces' que coincideixen amb el text entrat
    private handleSuggestionsFetchRequested = ({value}) => {
        if (this.rcState.selFincaNumero && this.rcState.selFincaNumero.DESCR === value) {
            this.rcState.dataFincaNumero = [this.rcState.selFincaNumero];
        } else {
            this.rcState.setInputFINCAADR(value, this.props);
        }
    };

    // Netegem la llista d'adreces o de fincques
    private handleSuggestionsClearRequested = () => {
        this.rcState.dataFincaNumero = [];
    };
    
    // Per actualitzar l'Autocomplete quan canviem el NumCod, de FinCod o de referència cadastral
    // eslint-disable-next-line react/no-deprecated
    componentWillReceiveProps(nextProps: IPropsRefCadAdrWidget) {
//        console.log(nextProps.numCod, this.rcState.selFincaNumero ? this.rcState.selFincaNumero.NUMCOD : 'null', nextProps.finCod, this.rcState.selFincaNumero ? this.rcState.selFincaNumero.FINCOD : 'null');
        if (nextProps.numCod && (!this.rcState.selFincaNumero || nextProps.numCod !== this.rcState.selFincaNumero.NUMCOD)) {
            this.rcState.setNumeroByNumCod(nextProps.numCod);
        } else if (nextProps.finCod && (!this.rcState.selFincaNumero || nextProps.finCod !== this.rcState.selFincaNumero.FINCOD)) {
            this.rcState.setFincaByFinCod(nextProps.finCod);
        } else if (nextProps.finRefCad1 && nextProps.finRefCad2 && 
                   (!this.rcState.selFincaNumero || 
                    nextProps.finRefCad1 !== this.rcState.selFincaNumero.FINREFCAD1 ||
                    nextProps.finRefCad2 !== this.rcState.selFincaNumero.FINREFCAD2)) {
            this.rcState.setFincaByRefCad(nextProps.finRefCad1, nextProps.finRefCad2);
        }
    }

    handleChange = (item?: IFincaNumero) => {
        // if (!item) {
        //     console.log("handleChange -> ??")
        // } else {
        //     if (!item.DESCR) {
        //         console.log("handleChange -> ?")
        //     } else {
        //         console.log("handleChange ->" + item.DESCR);
        //     }
        // }        
        this.rcState.selFincaNumero = item;
        if (this.props.onChange) {
            this.props.onChange(item);
        }
    }

    // Render !
    render(): JSX.Element {        
        let vFld = '';
        let dSource : IFincaNumero[];
        // Ordenem el DataSource
        if (this.rcState.dataFincaNumero && this.rcState.dataFincaNumero.length > 0) {
            dSource = toJS(this.rcState.dataFincaNumero).sort((itemA: IFincaNumero, itemB: IFincaNumero) => {
                const nameA = (itemA.ADRECA || '').toUpperCase(); // ignore upper and lowercase
                const nameB = (itemB.ADRECA || '').toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                // names must be equal
                return 0;
            });
            if (this.rcState.dataFincaNumero[0].FINCOD) {
                vFld = 'FINCOD';
            } else if (this.rcState.dataFincaNumero[0].NUMCOD) {
                vFld = 'NUMCOD';
            } else {
                vFld = "COORD";
            }
        } else {
            dSource = []
        }
        const hasError = this.props.required && !this.rcState.selFincaNumero;
        // Això fa que "val" només agafi valor quan dSource estigui ple,
        // Si no el AutoComplete no agafava el valor correctament.
        // Ara ja no caldria per que hem arreglat el AutoComplete
        const val: number = dSource.length > 0 ? this.props.numCod || this.props.finCod || 0 : 0;
        // Rederitzem
        return (
            <>
                {!this.props.readonly && <AjtAutoComplete
                    label={this.props.floatingLabelText}
                    value={val}
                    valueField={vFld}
                    displayField={'DESCR'}
                    showClear={true}
                    placeholder={this.props.hintText}
                    onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                    onChange={(item?: IFincaNumero) => { this.handleChange(item); }}
                    takeFirstWhenNoValue={true}
                    dataSource={dSource}
                    error={hasError}
                    helperText={hasError ? "Obligatori" : ""}
                    required={this.props.required}
                    InputProps={{ fullWidth: true }}
                />}
                {this.props.readonly && <TextField 
                    fullWidth={true} 
                    label={this.props.floatingLabelText}
                    value={this.rcState.selFincaNumero ? this.rcState.selFincaNumero.DESCR : ''}
                    InputProps={{ readOnly: true }}
                    error={hasError}
                    helperText={hasError ? "Obligatori" : ""}
                    required={this.props.required}
                />}
            </>
        );
    }
}